import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { ResetBadgeRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { ResetBadgeResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const resetBadge = (request: ResetBadgeRequest, options?: CashRequestOptions) =>
  post<ResetBadgeRequest, ResetBadgeResponse>('/2.0/cash/reset-badge', request, { ...options, rejectOnError: true })
